import * as Actions from "./actions";
import ApiService from "../../../../utils/apiService";
import * as Path from './apiRoutes';

const fetchDefault = (payload) => (dispatch) => {
    return ApiService.get(Path.ORDER_UPLOAD, setParams(payload))
        .then((response) => {
            dispatch(Actions.setList(response.data.data));
        })
};

const fetchDetailsList = (payload, historyNo) => (dispatch) => {
    return ApiService.post(Path.ORDER_UPLOAD + "/" + historyNo, setParams(payload))
        .then((response) => {
            dispatch(Actions.setDetailsList(response.data.data));
        })
};

const downloadFile = () => () => {
    return ApiService.post(Path.ORDER_DOWNLOAD, {}, true)
        .then((response) => {
            let fileDownload = require('react-file-download');
            fileDownload(response.data, '受注アップロードデータ_フォーマット.csv');
        })
};

const uploadFile = (file, userCd, riyokigyoId) => () => {
    const formData = new FormData();
    formData.append('file', file)

    return ApiService.post(Path.ORDER_UPLOAD + "/" + userCd + "/" + riyokigyoId, formData)
        .then((response) => {
            return response.data.data
        })
};

const setParams = (payload) => {
    let params = new URLSearchParams();

    Object.keys(payload).map((key) =>
        params.append(key, payload[key])
    );

    return params;
}

export {
    fetchDefault,
    fetchDetailsList,
    downloadFile,
    uploadFile
};
